import axios from 'axios';

export const securities_analysis = {
    getSecuritiesAnalysisData() {
        return axios({
            method: 'GET',
            maxBodyLength: Infinity,
            url: `${process.env.VUE_APP_API}/securities_analysis`,
        })
            .then(function (response) {
                return response.data
            }).catch(() => {
                return false
            });
    },
};